import api from '../token';

export const ListCliente = async () => {
  try {
    const response = await api.post('/getCliente');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

